export const tableSummaryStyles = {
    container: {
        flexGrow: 1,
        display: "flex",
        border: ({ palette }) => `1px solid ${palette.greyscale[200]}`,
        borderRadius: "10px",
        height: "300px"
    },
    schemaContainer: {
        width: "250px",
        height: "100%",
        overflow: "hidden",
        borderRight: ({ palette }) => `1px solid ${palette.greyscale[200]}`
    },
    schemaItemContainer: isSchemaActive => ({
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        px: 2,
        backgroundColor: isSchemaActive ? "greyscale.100" : "transparent",
        borderTop: isSchemaActive ? "1px solid" : "none",
        borderBottom: isSchemaActive ? "1px solid" : "none",
        borderColor: "greyscale.200",
        "&:hover": {
            backgroundColor: isSchemaActive ? "greyscale.100" : "greyscale.100"
        }
    }),
    tableContainer: {
        flexGrow: 1,
        overflow: "auto"
    }
};
